exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li.active.open ul.dropdown-menu {\n    position: relative;\n    float: none;\n}\nspan.caret {\n    position: absolute;\n    right: 51px;\n    top: 23px;\n}\n\n.dropdown-menu .active{\n    color: #000000;\n    font-size: 15px;\n    font-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/shared/left-nav/left-nav.component.css
// module id = ../../../../../src/app/shared/left-nav/left-nav.component.css
// module chunks = main